import React from 'react'
import Image from 'next/image'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import Campus1 from '@/images/campus/campus-1.jpg'
import Campus2 from '@/images/campus/campus-2.jpg'
import Campus3 from '@/images/campus/campus-3.jpg'
import Campus4 from '@/images/campus/campus-4.jpg'
import Campus5 from '@/images/campus/campus-5.jpg'
import Campus6 from '@/images/campus/campus-6.jpg'
import Campus7 from '@/images/campus/campus-7.jpg'
import Campus9 from '@/images/campus/campus-9.jpg'
import Campus10 from '@/images/campus/campus-10.jpg'

const OurCampus = () => {
  const images = [Campus1, Campus2, Campus3, Campus4, Campus5, Campus6, Campus7, Campus9, Campus10]
  const campusImages = images.map((image, i) => ({ id: i + 1, image }))

  function NextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={`${className} z-10 !h-[32px] md:!h-[60px] !w-[32px] md:!w-[60px] transition hover:opacity-80 cursor-pointer rounded-full !bg-white flex items-center justify-center shadow-lg !before:hidden hover:text-white !right-[10px] md:!right-[30px]`}
        style={{ ...style, display: 'flex' }}
        onClick={onClick}
      >
        <IoIosArrowForward className="text-[16px] md:text-[24px]" />
      </div>
    )
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={`${className} z-10 !h-[32px] md:!h-[60px] !w-[32px] md:!w-[60px] transition hover:opacity-80 cursor-pointer rounded-full !bg-white flex items-center justify-center shadow-lg !before:hidden hover:text-white !left-[10px] md:!left-[30px]`}
        style={{ ...style, display: 'flex' }}
        onClick={onClick}
      >
        <IoIosArrowBack className="text-[16px] md:text-[24px]" />
      </div>
    )
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    variableWidth: true,
  }

  return (
    <div className="w-full max-w-[90%] mx-auto py-[60px] md:py-[100px] overflow-hidden">
      <h2 className="text-[32px] md:text-[64px] xl:text-[80px] font-[500] mb-[12px] md:mb-[32px] bg-gradient-to-b from-[#091F59] to-[#1A3884] bg-clip-text text-transparent">
        Kampusumuz
      </h2>
      <div className="relative">
        <Slider {...settings} className="our-campus-slider">
          {campusImages.map((item) => (
            <div key={item.id} className="pr-[30px]">
              <div className="relative w-[220px] xs:!w-[280px] md:!w-[360px] lg:!w-[510px] h-[200px] xs:!h-[260px] md:!h-[330px] lg:!h-[480px] rounded-[20px] overflow-hidden flex-shrink-0">
                <Image
                  src={item.image}
                  alt={`Campus ${item.id}`}
                  fill
                  sizes="(max-width: 640px) 280px, (max-width: 768px) 360px, (max-width: 1024px) 510px, 510px"
                  placeholder="blur"
                  priority={item.id === 1}
                  loading={item.id === 1 ? 'eager' : 'lazy'}
                  className="object-cover rounded-[20px]"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}

export default OurCampus
